import { render, staticRenderFns } from "./ApiName.vue?vue&type=template&id=7f90ea95&scoped=true&lang=pug&"
import script from "./ApiName.vue?vue&type=script&lang=ts&"
export * from "./ApiName.vue?vue&type=script&lang=ts&"
import style0 from "./ApiName.vue?vue&type=style&index=0&id=7f90ea95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f90ea95",
  null
  
)

export default component.exports